import apiClient from "..";
import AnalyticsStore from "../../store/AnalyticsStore";
import UserStore from "../../store/UserStore";
import { getCookie } from "../../utils/cookie";

export const getPortfolioAssetClasses = (familyId1, userId1) => {
  const familyId = UserStore?.userData?.family_id || getCookie("famid");
  const isPrimary =
    (AnalyticsStore?.overall?.isPrimary ||
      JSON.parse(getCookie("isPrimary"))) &&
    UserStore.getData === "fam"
      ? true
      : false;
  const userId =
    !isPrimary && (AnalyticsStore?.overall?.userId || getCookie("userid"));
  const uri = !userId
    ? `families/${familyId}/portfolioassetclasses` // 2 is for equity tab only
    : `clients/${userId}/portfolioassetclasses`;
  return apiClient.get(uri, {
    params: {
      classType: "",
      assetClassId: "",
      isInfinity: UserStore?.isInfinity,
      MeasureInstrumentId: "",
      advisor: "",
      isHolding: "0",
    },
  });
};

export const getFamilyAssetAllocationOverTime = () => {
  const familyId = UserStore?.userData?.family_id || getCookie("famid");
  const isPrimary =
    (AnalyticsStore?.overall?.isPrimary ||
      JSON.parse(getCookie("isPrimary"))) &&
    UserStore.getData === "fam"
      ? true
      : false;
  const userId =
    !isPrimary && (AnalyticsStore?.overall?.userId || getCookie("userid"));
  if (!userId) {
    return apiClient.get(
      `families/${familyId}/analytics/assetallocationovertime`
    );
  } else {
    return apiClient.get(`clients/${userId}/analytics/assetallocationovertime`);
  }
};

export const getPortfolioAgeing = (familyIds, userIds, instrumentVehicleId) => {
  const familyId = UserStore?.userData?.family_id || getCookie("famid");
  const isPrimary =
    (AnalyticsStore?.overall?.isPrimary ||
      JSON.parse(getCookie("isPrimary"))) &&
    UserStore.getData === "fam"
      ? true
      : false;
  const userId =
    !isPrimary && (AnalyticsStore?.overall?.userId || getCookie("userid"));

  if (!userId) {
    return apiClient.get(`families/${familyId}/analytics/portfolioageing`, {
      params: {
        instrumentvehicle_id_csv:
          instrumentVehicleId !== "All" ? instrumentVehicleId?.join(",") : "",
      },
    });
  } else {
    return apiClient.get(`clients/${userId}/analytics/portfolioageing`, {
      params: {
        instrumentvehicle_id_csv:
          instrumentVehicleId !== "All" ? instrumentVehicleId?.join(",") : "",
      },
    });
  }
};

export const getPortfolioAgeingOptions = () => {
  const familyId = UserStore?.userData?.family_id || getCookie("famid");
  const isPrimary =
    (AnalyticsStore?.overall?.isPrimary ||
      JSON.parse(getCookie("isPrimary"))) &&
    UserStore.getData === "fam"
      ? true
      : false;

  const userId =
    !isPrimary && (AnalyticsStore?.overall?.userId || getCookie("userid"));
  if (!userId) {
    return apiClient.get(
      `families/${familyId}/portfolio/assetclasses/assetclassid/instrumentvehicles`
    );
  } else {
    return apiClient.get(
      `clients/${userId}/portfolio/assetclasses/assetclassid/instrumentvehicles`
    );
  }
};

export const getInvestmentValue = () => {
  const familyId = UserStore?.userData?.family_id || getCookie("famid");
  const isPrimary =
    (AnalyticsStore?.overall?.isPrimary ||
      JSON.parse(getCookie("isPrimary"))) &&
    UserStore.getData === "fam"
      ? true
      : false;

  const userId =
    !isPrimary && (AnalyticsStore?.overall?.userId || getCookie("userid"));
  if (!userId) {
    return apiClient.get(
      `families/${familyId}/analytics/investmentvalueandcurrentvalueovertime`
    );
  } else {
    return apiClient.get(
      `clients/${userId}/analytics/investmentvalueandcurrentvalueovertime`
    );
  }
};

export const getAmcExposure = (familyId1, userId1, instrumentType) => {
  const familyId = UserStore?.userData?.family_id || getCookie("famid");
  const isPrimary =
    (AnalyticsStore?.overall?.isPrimary ||
      JSON.parse(getCookie("isPrimary"))) &&
    UserStore.getData === "fam"
      ? true
      : false;
  const userId =
    !isPrimary && (AnalyticsStore?.overall?.userId || getCookie("userid"));
  if (!userId) {
    return apiClient.get(`families/${familyId}/analytics/amcexposure`, {
      params: {
        asset_class_id: instrumentType !== 0 ? instrumentType : "",
      },
    });
  } else {
    return apiClient.get(`clients/${userId}/analytics/amcexposure`, {
      params: {
        asset_class_id: instrumentType !== 0 ? instrumentType : "",
      },
    });
  }
};

export const getMfExposure = (familyId1, userId1, instrumentType) => {
  const familyId = UserStore?.userData?.family_id || getCookie("famid");
  const isPrimary =
    (AnalyticsStore?.overall?.isPrimary ||
      JSON.parse(getCookie("isPrimary"))) &&
    UserStore.getData === "fam"
      ? true
      : false;
  const userId =
    !isPrimary && (AnalyticsStore?.overall?.userId || getCookie("userid"));
  if (!userId) {
    return apiClient.get(`families/${familyId}/analytics/mfcategoryexposure`, {
      params: {
        asset_class_id: instrumentType !== 0 ? instrumentType : "",
      },
    });
  } else {
    return apiClient.get(`clients/${userId}/analytics/mfcategoryexposure`, {
      params: {
        asset_class_id: instrumentType !== 0 ? instrumentType : "",
      },
    });
  }
};

export const getPortfolioAllocation = (familyId1, userId1, portfolioType) => {
  const familyId = UserStore?.userData?.family_id || getCookie("famid");
  const isPrimary =
    (AnalyticsStore?.overall?.isPrimary ||
      JSON.parse(getCookie("isPrimary"))) &&
    UserStore.getData === "fam"
      ? true
      : false;
  const userId =
    !isPrimary && (AnalyticsStore?.overall?.userId || getCookie("userid"));
  if (!userId) {
    return apiClient.get(
      `/families/${familyId}/analytics/modelportfoliocomparison`
    );
  } else {
    return apiClient.get(
      `/clients/${userId}/analytics/modelportfoliocomparison`
    );
  }
};
